import {
  SanityFeaturedVideoTeaser,
  SanityImageText,
} from '../../types/generated/graphql-types'
import { ImageTextProps } from '../components/blocks/ImageText'
import { ImageProps } from '../components/Image'
import { Breakpoints } from '../utilities/breakpoints'
import { validImage } from '../utilities/imageFilters'
import { Presets } from '../utilities/imagePreset'
import { getImagePropsWithSources } from '../utilities/imagePropUtils'
import { isNullOrWhiteSpace } from '../utilities/string'
import { mapSanityLinkToInternalExternalLink } from './LinkMapper'

export const mapSanityImageTextToImageTextProps = ({
  buttonLink,
  buttonTitle,
  image,
  isBackgroundImage,
  subtitle,
  text,
  title,
}: SanityImageText): ImageTextProps => {
  let imageProps: ImageProps | undefined

  if (image) {
    if (isBackgroundImage) {
      imageProps = validImage(image)
        ? getImagePropsWithSources(
            image,
            {
              small: Presets.imageTextBackground.small,
              medium: Presets.imageTextBackground.medium,
              large: Presets.imageTextBackground.large,
              extraLarge: Presets.imageTextBackground.extraLarge,
            },
            Breakpoints.tb,
            Breakpoints.lg,
            Breakpoints.xl
          )
        : undefined
    } else {
      imageProps = validImage(image)
        ? getImagePropsWithSources(
            image,
            {
              small: Presets.imageTextBox.small,
              medium: Presets.imageTextBox.medium,
              large: Presets.imageTextBox.large,
            },
            Breakpoints.tb,
            Breakpoints.xl
          )
        : undefined
    }
  }

  const linkUrl = buttonLink?.page?.path ?? undefined

  return {
    link: !isNullOrWhiteSpace(linkUrl)
      ? {
          title: buttonTitle ?? '',
          url: linkUrl,
        }
      : undefined,
    image: imageProps,
    isBackgroundImage: isBackgroundImage ?? undefined,
    subtitle: subtitle ?? undefined,
    text: text ?? undefined,
    title: title ?? undefined,
  }
}

export const mapSanityFeaturedVideoTeaserToImageTextProps = ({
  body,
  description,
  image,
  link,
  title,
  video,
}: SanityFeaturedVideoTeaser): ImageTextProps => ({
  image: validImage(image)
    ? getImagePropsWithSources(
        image,
        {
          small: Presets.imageTextBox.small,
          medium: Presets.imageTextBox.medium,
          large: Presets.imageTextBox.large,
        },
        Breakpoints.tb,
        Breakpoints.xl
      )
    : undefined,
  link: link ? mapSanityLinkToInternalExternalLink(link) : undefined,
  subtitle: description ?? undefined,
  text: body ?? undefined,
  title: title ?? undefined,
  videoUrl: video?.url ?? undefined,
})
